module.exports = __webpack_public_path__ + "img/icon-swap.15fd18ea.svg";